import React from 'react'
import Topheader from '../Home/topHeader/Topheader'
import Middlebar from '../Home/middleBar/Middlebar'
import NavMenu from '../Home/navigationBar/NavMenu'
import Footer from '../Home/footer/Footer'
import { Link } from "react-router-dom";
// import Mensory from './Mensory'
import { Card, CardHeader, CardBody, CardFooter, Stack, Heading, Button, ButtonGroup, Divider, Text,  } from '@chakra-ui/react'

const Gallery = () => {
  return (
    <>
     <Topheader/>
     <Middlebar/>
     {/* <!-- gallery --> */}
     <NavMenu/>
     <div className="main-gallery">
      <div className="">
        <div className="image my-2 flex justify-center ">
          <img src="about.png" className='object-cover blur-sm  w-[1500px] h-[250px] ' alt="" />
          <h1 className='flex justify-center absolute mt-20 mx-[550px] font-poppins shadow-md text-[70px] text-white'>GALLERY</h1>
          </div> 
          <div className="cards mx-20 space-x-6 my-24 justify-center flex">
            <div className="card w-[350px]  ">
              <Link to='/Orientation'>
                    <Card maxW='sm' className="shadow-xl rounded-xl h-[398px]">
                     <CardBody>
                       <img
                            src='eimsorien.jpg'
                            alt='ANNIVERSARY'
                            className="rounded-lg h-[263px]"
                            />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">Orientation</Heading>
                            <Text className="text-center p-5 ">
                            Orientation at
                            Emaan Institute of Management Sciences
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
                            </Link>
            </div>
            <div className="card w-[350px]  ">
              <Link to='/Independence'>

                    <Card maxW='sm' className="shadow-xl rounded-xl h-[430px]">
                     <CardBody>
                       <img
                            src='14AUG1.jpeg'
                           alt='Green double couch with wooden legs'
                           className="rounded-lg"
                           />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">INDEPENDENCE DAY OF PAKISTAN</Heading>
                            <Text className="text-center p-5 ">
                            Independence Day Celebrations at Emaan Institute of Management and Sciences 🇵🇰🎈"
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
                           </Link>
            </div>
            <div className="card w-[350px]  ">
              <Link to='/Qawali'>

                    <Card maxW='sm' className="shadow-xl rounded-xl h-[398px]">
                     <CardBody>
                       <img
                            src='gallery4.jpg'
                            alt='Green double couch with wooden legs'
                            className="rounded-lg h-[263px]"
                            />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">Qawali Night</Heading>
                            <Text className="text-center p-5 ">
                            Qawali Night at 
                            Emaan Institute of Management Sciences
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
                            </Link>
            </div>
           
          </div>
          <div className="cards mx-20 space-x-6 my-24 justify-center flex">
            <div className="card w-[350px]  ">
              <Link to='/Sports'>

                    <Card maxW='sm' className="shadow-xl rounded-xl h-[398px]">
                     <CardBody>
                       <img
                            src='gallery2.jpg'
                            alt='Green double couch with wooden legs'
                            className="rounded-lg h-[263px] w-"
                            />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">Sports Day</Heading>
                            <Text className="text-center p-5 ">
                            Cricket at 
                            Emaan Institute of Management Sciences
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
                            </Link>
            </div>
            <div className="card w-[350px]  ">
              <Link to="/ProjectEvaluation">

                    <Card maxW='sm' className="shadow-xl rounded-xl h-[430px]">
                     <CardBody>
                       <img
                            src='PE2.jpeg'
                           alt='Green double couch with wooden legs'
                           className="rounded-lg h-[263px] w-full"
                         />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">Project Evaluation</Heading>
                            <Text className="text-center p-5 ">
                            Project Evaluation at 
                            Emaan Institute of Management Sciences
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
              </Link>
            </div>
            <div className="card w-[350px]  ">
              
                    <Card maxW='sm' className="shadow-xl rounded-xl h-[398px]">
                     <CardBody>
                       <img
                            src='AN1.jpeg'
                           alt='Green double couch with wooden legs'
                           className="rounded-lg"
                         />
                      <Stack mt='6' spacing='3'>
                        <Heading className="text-center text-xl mt-2">EIMS Anniversary</Heading>
                            <Text className="text-center p-5 ">
                            Celebrating the Anniversary of 
                            Emaan Institute of Management Sciences
                               </Text>
                                </Stack>
              </CardBody>
                   </Card>
            </div>
           
          </div>
        

      </div>
     </div>
     <Footer/>
    </>
  )
}

export default Gallery
